export const LANGUAGES = {
  he: { name: 'עברית', short: 'עב', dir: 'rtl' },
  en: { name: 'English', short: 'EN', dir: 'ltr' },
  ar: { name: 'العربية', short: 'ع', dir: 'rtl' },
} as const

export type LanguageCode = keyof typeof LANGUAGES

export const ROUTES = {
  HOME: '/',
  PRODUCTS: '/products',
  ABOUT: '/about',
  CONTACT: '/contact',
} as const

/** Product detail route, e.g. productPath('bms') → /products/bms */
export const productPath = (slug: string) => `/products/${slug}`

/** Contact route with an optional preselected product and topic. */
export const contactPath = (opts: { product?: string; topic?: string } = {}) => {
  const params = new URLSearchParams()
  if (opts.product) params.set('product', opts.product)
  if (opts.topic) params.set('topic', opts.topic)
  const qs = params.toString()
  return qs ? `${ROUTES.CONTACT}?${qs}` : ROUTES.CONTACT
}

export const CONTACT_INFO = {
  email: import.meta.env.VITE_CONTACT_EMAIL || 'admin@tdrem.com',
  phone: import.meta.env.VITE_PHONE || '',
  address: {
    he: 'ישראל',
    en: 'Israel',
    ar: 'إسرائيل',
  },
}
